/**
 * Url handling shared by the cache key and the policy registry.
 *
 * Both have to agree on what part of a url identifies a request, or a url
 * would match a policy under one rule and be keyed under another.
 */

/** A url without its `#fragment`, which is never sent to the server. */
export function withoutFragment(url: string): string {
  const hash = url.indexOf('#');
  return hash === -1 ? url : url.slice(0, hash);
}
